// ============================================================
// DATA MODEL – PrimeFix Solutions Limited
// Sourced from tender document & Form A/B
// ============================================================

export const company = {
  name: "PrimeFix Solutions Limited",
  tagline: "Reliable Solutions. Exceptional Service.",
  established: "January 2016",
  description:
    "PrimeFix Solutions Limited is a New Zealand–based operations and maintenance company delivering integrated facility management across commercial, residential, industrial, hospitality, and educational sectors. With a decade of proven expertise, we combine technical excellence with an unwavering commitment to client satisfaction.",
  phone: "+64 27 298 9193",
  email: "work@primefixsolutions.co.nz",
  address: "Hamilton, New Zealand",
  website: "primefixsolutions.co.nz",
};
export const stats = [
  { value: "10+", label: "Years Experience" },
  { value: "10+", label: "Service Disciplines" },
  { value: "100%", label: "NZ Compliance" },
];

export const services = [
  {
    id: "mep",
    icon: "⚡",
    title: "MEP Systems Maintenance",
    description:
      "Comprehensive mechanical, electrical, and plumbing maintenance covering distribution boards, UPS, ATS, backup generators, pumps, and full electrical safety systems.",
    items: [
      "Electrical Distribution & Switchgear",
      "Backup Generator & ATS Maintenance",
      "UPS Systems",
      "Plumbing & Sanitary Works",
      "Lightning Protection (NFPA 780)",
      "Pump Systems",
    ],
  },
  {
    id: "hvac",
    icon: "🌡️",
    title: "HVAC & Cooling Systems",
    description:
      "Full-scope HVAC maintenance for split, packaged, VRV/VRF, chiller, air handling units, fan coils, boilers, and hot water systems.",
    items: [
      "Split & Packaged AC Units",
      "VRV / VRF Systems",
      "Air Handling Units (AHU)",
      "Chiller Systems",
      "Boiler & Hot Water Heaters",
      "Duct & Ventilation Systems",
    ],
  },
  {
    id: "civil",
    icon: "🏛️",
    title: "Civil & Architectural Works",
    description:
      "Structural and architectural maintenance including roofing, facades, waterproofing, flooring, painting, carpentry, and complete fit-out services.",
    items: [
      "Doors, Windows & Facades",
      "Waterproofing & Leak Repair",
      "Painting & Finishing",
      "False Ceilings & Partitions",
      "Flooring & Surface Works",
      "Roofing Maintenance",
    ],
  },
  {
    id: "fire",
    icon: "🛡️",
    title: "Fire Safety Systems",
    description:
      "Installation, inspection, and preventive maintenance of fire detection, alarm, and suppression systems to the highest safety standards.",
    items: [
      "Fire Alarm & Detection",
      "Sprinkler Systems",
      "FM200 Suppression Systems",
      "Fire Extinguisher Servicing",
      "Emergency Lighting",
      "Fire Hose & Hydrant Systems",
    ],
  },
  {
    id: "ifm",
    icon: "🏢",
    title: "Integrated Facility Management",
    description:
      "End-to-end facility management solutions including custodial services, pest control, landscaping, pool maintenance, and AV systems.",
    items: [
      "Swimming Pool Maintenance",
      "Audio-Visual Systems",
      "Landscaping & Grounds",
      "Pest Control",
      "Custodial & Cleaning",
      "Inventory Management",
    ],
  },
  {
    id: "preventive",
    icon: "📋",
    title: "Preventive & Corrective Maintenance",
    description:
      "Structured maintenance programs with daily, weekly, monthly, and annual schedules ensuring peak performance and compliance reporting.",
    items: [
      "Daily Routine Maintenance",
      "Preventive Maintenance Plans",
      "Corrective Maintenance",
      "Emergency Response (24/7)",
      "Performance Reporting",
      "Compliance Documentation",
    ],
  },
];

export const projects = [
  {
    id: 1,
    title: "International School Campus O&M",
    client: "Dilworth School",
    type: "Roofing, Electrical, HVAC & Plumbing Maintenance",
    duration: "5 Years",
    start: 2021,
    end: 2026,
    status: "active",
    category: "Education",
    featured: true,
  },
  {
    id: 2,
    title: "Grade A Commercial Office Tower",
    client: "Private Developer",
    type: "Integrated Facility Management",
    duration: "2 Years",
    start: 2022,
    end: 2024,
    status: "completed",
    category: "Commercial",
    featured: true,
  },
  {
    id: 3,
    title: "Luxury Residential Estate",
    client: "Real Estate Group",
    type: "Full Facility Management Service",
    duration: "3 Years",
    start: 2020,
    end: 2023,
    status: "completed",
    category: "Residential",
    featured: true,
  },
  {
    id: 4,
    title: "Multi-Speciality Hospital Maintenance",
    client: "Healthcare Group",
    type: "Critical MEP Systems Maintenance",
    duration: "2 Years",
    start: 2024,
    end: 2026,
    status: "active",
    category: "Healthcare",
    featured: true,
  },
  {
    id: 5,
    title: "Five-Star Hotel Facility Maintenance",
    client: "Hospitality Group",
    type: "HVAC, Plumbing & Civil Maintenance",
    duration: "3 Years",
    start: 2019,
    end: 2022,
    status: "completed",
    category: "Hospitality",
    featured: false,
  },
  {
    id: 6,
    title: "International School Campus O&M",
    client: "Birkdale North School",
    type: "Roofing, Electrical, HVAC & Plumbing Maintenance",
    duration: "3 Years",
    start: 2022,
    end: 2025,
    status: "active",
    category: "Education",
    featured: false,
  },
  {
    id: 7,
    title: "High-End Residential Tower",
    client: "Private Developer (H47, Auckland CBD)",
    type: "HVAC, Plumbing & Electrical Systems Maintenance",
    duration: "2 Years",
    start: 2022,
    end: 2024,
    status: "completed",
    category: "Residential",
    featured: false,
  },
  {
    id: 8,
    title: "Industrial Processing Plant Maintenance",
    client: "Industrial Client (Mayceys, Auckland)",
    type: "Mechanical & Electrical Systems Maintenance",
    duration: "2 Years",
    start: 2024,
    end: 2026,
    status: "active",
    category: "Industrial",
    featured: false,
  },
  {
    id: 9,
    title: "Mixed-Use Development Facility Management",
    client: "Real Estate Group",
    type: "Integrated Facility Management",
    duration: "3 Years",
    start: 2020,
    end: 2023,
    status: "completed",
    category: "Commercial",
    featured: false,
  },
  {
    id: 10,
    title: "Regional Shopping Mall Maintenance",
    client: "Retail Group",
    type: "Electrical, Fire Systems & Civil Works Maintenance",
    duration: "3 Years",
    start: 2019,
    end: 2022,
    status: "completed",
    category: "Retail",
    featured: false,
  },
];

export const team = [
  { role: "Project Manager", description: "On-demand & regular oversight" },
  { role: "HVAC Technician", description: "Cooling & ventilation specialist" },
  { role: "Electrical Technician", description: "Power & lighting systems" },
  { role: "Mechanical Technician", description: "Plant & equipment" },
  { role: "Plumber", description: "Water & sanitary systems" },
  { role: "Civil Works Technician", description: "Carpenter / Painter / Builder" },
];

export const whyUs = [
  {
    title: "10+ Years of Expertise",
    text: "Operating since January 2016 with proven experience across diverse asset types in New Zealand.",
  },
  {
    title: "24/7 Emergency Response",
    text: "Immediate on-call attendance for power outages, flooding, and critical system failures—no additional charge.",
  },
  {
    title: "Structured Maintenance Plans",
    text: "Daily, preventive, corrective, and emergency maintenance programs with detailed compliance reporting.",
  },
  {
    title: "Qualified Personnel",
    text: "All technicians hold relevant trade certifications and are vetted by clients prior to assignment.",
  },
  {
    title: "Single Point of Accountability",
    text: "Dedicated project supervisor on-site at all times, ensuring seamless communication with your team.",
  },
  {
    title: "Transparent Reporting",
    text: "Daily, weekly, monthly, and annual performance reports delivered to facilities managers on schedule.",
  },
];

export const categories = [
  "All",
  "Education",
  "Commercial",
  "Residential",
  "Healthcare",
  "Hospitality",
  "Industrial",
  "Retail",
];
